function requireJs(url: string) {
  return new Promise<void>((resolve) => {
    const doc = document;
    const head =
      doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
    const node = doc.createElement('script');
    node.onload = () => {
      resolve();
    };
    node.onerror = () => {};
    node.src = url;
    head.appendChild(node);
  });
}

export default requireJs;
